export const platformIdentity = {
  legalBusinessName: import.meta.env.VITE_LEGAL_BUSINESS_NAME || "DOSSEY'S STUDIO LLC",
  legalContact: import.meta.env.VITE_LEGAL_CONTACT || "DARRIN DOSSEY",
  legalContactEmail: import.meta.env.VITE_LEGAL_CONTACT_EMAIL || "darrindossey@gmail.com",
  productBrandName: import.meta.env.VITE_PRODUCT_BRAND_NAME || "Oche League Manager",
  productSupportEmail: import.meta.env.VITE_PRODUCT_SUPPORT_EMAIL || "support@ocheleague.com"
};

export const applyPlatformIdentity = value => {
  if (value) Object.assign(platformIdentity, value);
  document.title = platformIdentity.productBrandName;
};
